<template>
  <el-dialog :title="$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.ChangePassword')" :visible.sync="visible" :close-on-click-modal="false" width="500px" class="accountSet" @close="cancel">
    <el-radio-group v-model="tabs" style="margin-bottom: 30px;">
      <el-radio-button label="phone" :disabled="!accountForm.phone">Mobile phone verification</el-radio-button>
      <el-radio-button label="email" :disabled="!accountForm.email">Email verification</el-radio-button>
    </el-radio-group>

    <p v-if="seconds">{{ $t('setting.Tips1') }} {{ tabs === 'phone' ? accountForm.phone : accountForm.email}}</p>
    <p v-else>{{ $t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips7') }}</p>
    <el-form ref="accountForm" label-position="top" label-width="140px" :model="accountForm" :rules="accountFormRules">
      <el-form-item :label="$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.VerificationCode')" prop="verificationCode">
        <el-input v-model="accountForm.verificationCode" :placeholder="$t('setting.verificationCodePlaceholder')" style="width: 100%;">
          <template slot="append">
            <span :loading="loading" class="pointer" size="large" @click="sendVertificationCode" v-if="seconds===0">
              <el-button>{{sendText}}</el-button>
            </span>
          </template>
        </el-input>
        <p style="padding:0;" v-if="seconds>0">{{ $t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips2') }} <span style="color: #99C41C!important;">{{seconds}}</span>s {{ $t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.later') }}</p>
      </el-form-item>
      <el-form-item :label="$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Password')" prop="password">
        <el-input v-model="accountForm.password" style="width: 100%;" type="password" :placeholder="$t('setting.passwordPlaceholder')" autocomplete="new-password"></el-input><!-- 邮箱不可更改7.26 -->
      </el-form-item>
      <el-form-item :label="$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.ConfirmPassword')" prop="checkPassword">
        <el-input v-model="accountForm.checkPassword" style="width: 100%;" type="password" :placeholder="$t('setting.passwordPlaceholder')" autocomplete="new-password"></el-input>
      </el-form-item>
      <p style="word-break:keep-all;">{{ $t('setting.Tips2') }}</p>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">{{$t('currency.cancel')}}</el-button>
      <el-button size="small" type="primary" @click="changePassword">{{$t('currency.submit')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { encrypt } from '@/util/encryp.js'
import { pureNumber, hasCapital, hasLowercase, hasNumber } from '@/util/validate'
let checkPureNumber = (rules, value, callback) => {
  if (pureNumber(value)) {
    callback()
  } else {
    callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips3')}`))
  }
}
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('Home.Register.PasswordCheck1')))
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error(this.$t('Home.Register.PasswordCheck2')))
      } else if (!hasCapital(value) || !hasLowercase(value) || !hasNumber(value)) {
        callback(new Error(this.$t('Home.Register.PasswordCheck3')))
      } else {
        callback()
      }
    }

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips4')}`))
      } else if (value !== this.accountForm.password) {
        callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips5')}`))
      } else {
        callback()
      }
    }
    return {
      accountForm: {
        verificationCode: undefined,
        password: undefined,
        checkPassword: undefined
      },
      accountFormRules: {
        verificationCode: [{ validate: checkPureNumber, trigger: 'blur' }, { required: true, message: '', trigger: ['change', 'blur'] }],
        password: [{ required: true, message: `${this.$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips6')}`, trigger: ['change', 'blur'] }, { min: 8, max: 20, trigger: 'blur', message: 'Please enter a password of 8 to 20 characters' }, { validator: validatePass, trigger: 'blur' }],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }, { required: true, message: this.$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips4'), trigger: 'blur' }]
      },
      disabled: false,
      visible: false,
      loading: false,
      seconds: 0,
      timer: null,
      sendText: 'Send',
      tabs: 'phone'
    }
  },
  methods: {
    toggle(data) {
      this.accountForm.email = data.email
      this.accountForm.phone = data.phone
      this.visible = !this.visible
      this.tabs = data.phone ? 'phone' : 'email'
    },
    submit() {

    },
    cancel() {
      this.accountForm = {}
      this.$refs.accountForm.resetFields()
      this.sendText = 'Send'
      this.seconds = 0
      this.visible = false
    },
    sendVertificationCode() {
      this.loading = true
      let param = {}
      if (this.tabs === 'phone') param.phone = this.accountForm.phone
      else param.email = this.accountForm.email
      API.sendVertificationCode(param).then((res) => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        this.disabled = true
        this.sendText = 'Send Again'
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.disabled = false
            this.$forceUpdate()
            return
          }
          --this.seconds
        }, 1000)
      }).catch(result => {
        this.$message.error(result.data.message)
        this.disabled = false
      }).finally(() => {
        this.loading = false
      })
    },
    changePassword() {
      this.$refs.accountForm.validate(valid => {
        if (!valid) return
        let param = { verificationCode: this.accountForm.verificationCode }
        if (this.tabs === 'phone') param.phone = this.accountForm.phone
        else param.email = this.accountForm.email
        API.handleForgetPassword(param).then((res) => {
          if (res.code !== 10000) return this.$message.error(res.message)
          let setPassword = param
          setPassword.password = encrypt(this.accountForm.password)
          delete setPassword.verificationCode
          API.handleModifyPassword(setPassword).then(res => {
            this.$message.success(this.$t('promptText.msg1'))
            this.visible = false
            this.seconds = 0
            this.accountForm = {
              verificationCode: undefined,
              password: undefined,
              checkPassword: undefined
            }
          }).catch(result => {
            this.$message.error(result.data.message)
          })
        }).catch(result => {
          this.$message.error(result.data.message)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.accountSet /deep/ .el-form-item__label {
  padding-bottom: 0;
}

.accountSet /deep/.el-dialog__body {
  padding: 10px 28px;
}
p {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #747a87;
  padding-bottom: 10px;
  padding-left: 10px;
}
.code-button {
  display: inline-block;
  height: 34px;
  border-left: none;
  background: #fff;
}
/deep/.el-input-group--append .el-input__inner {
  border-radius: 2px 0 0 2px;
  border-right: 0;
}
/deep/.el-input-group__append {
  background: #fff;
  border-left: 0;
  color: #99c41c;
}
</style>
